// TEAMS Website - i18n Configuration
// Internationalization setup using react-i18next

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations, defaultLanguage } from './data/translations.js';

// Initialize i18n
i18n
  .use(initReactI18next)
  .init({
    // Language resources
    resources: {
      en: {
        translation: flattenTranslations(translations, 'en')
      },
      it: {
        translation: flattenTranslations(translations, 'it')
      }
    },

    // Default language
    lng: getInitialLanguage(),
    fallbackLng: defaultLanguage,

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Interpolation
    interpolation: {
      escapeValue: false // React already escapes by default
    },

    // React options
    react: {
      useSuspense: false
    }
  });

// Helper function to flatten nested translation object
function flattenTranslations(obj, lang) {
  const flattened = {};

  function flatten(current, prefix = '') {
    for (const key in current) {
      if (typeof current[key] === 'object' && current[key] !== null) {
        if (current[key][lang] !== undefined) {
          // This is a translation object with en/it keys
          flattened[prefix + key] = current[key][lang];
        } else {
          // This is a nested object, continue flattening
          flatten(current[key], prefix + key + '.');
        }
      } else {
        flattened[prefix + key] = current[key];
      }
    }
  }

  flatten(obj);
  return flattened;
}

// Get initial language from localStorage or browser preference
function getInitialLanguage() {
  // Check localStorage first
  const stored = localStorage.getItem('teams-language');
  if (stored && ['en', 'it'].includes(stored)) {
    return stored;
  }

  // Check browser language preference
  const browserLang = navigator.language || navigator.languages?.[0];
  if (browserLang) {
    const langCode = browserLang.split('-')[0];
    if (['en', 'it'].includes(langCode)) {
      return langCode;
    }
  }

  // Fall back to default language
  return defaultLanguage;
}

// Export i18n instance
export default i18n;

// Export helper functions
export { getInitialLanguage, flattenTranslations };

// Language change utility
export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem('teams-language', lang);
};


// Translation helper for dynamic keys
export const translate = (key, options = {}) => {
  return i18n.t(key, options);
};
